import classnames from 'classnames';
import DepartmentFilterActions from 'actions/DepartmentFilterActions';
import React from 'react';

export function DepartmentToggle({selected, department}) {
  return (
    <div
      className={classnames('department-toggle', {selected})}
      onClick={() => DepartmentFilterActions.toggleDepartment(department.id)}>
      {department.name}
      {selected && <XSVG />}
    </div>
  );
}

const XSVG = ({className, onClick}) => (
  <svg
    onClick={onClick}
    className={`x-svg ${className}`}
    width="8"
    height="8"
    viewBox="0 0 8 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.80555 1.13889C7.93533 1.00825 8.00043 0.851135 8 0.666668C8.00043 0.482202 7.93533 0.325091 7.80555 0.194447C7.67491 0.0646688 7.5178 -0.000431178 7.33333 2.15553e-06C7.14887 -0.000431844 6.99175 0.0646721 6.86111 0.194447L4 3.05556L1.13889 0.194447C1.00825 0.0646688 0.851135 -0.000431178 0.666668 2.15553e-06C0.482202 -0.000431844 0.325091 0.0646721 0.194447 0.194447C0.0646688 0.325091 -0.000431178 0.482202 2.15553e-06 0.666668C-0.000431844 0.851135 0.0646721 1.00825 0.194447 1.13889L3.05556 4L0.194447 6.86111C0.0646688 6.99175 -0.000431178 7.14887 2.15553e-06 7.33333C-0.000431844 7.5178 0.0646721 7.67491 0.194447 7.80555C0.325091 7.93533 0.482202 8.00043 0.666668 8C0.851135 8.00043 1.00825 7.93533 1.13889 7.80555L4 4.94444L6.86111 7.80555C6.99175 7.93533 7.14887 8.00043 7.33333 8C7.5178 8.00043 7.67491 7.93533 7.80555 7.80555C7.93533 7.67491 8.00043 7.5178 8 7.33333C8.00043 7.14887 7.93533 6.99175 7.80555 6.86111L4.94444 4L7.80555 1.13889Z"
      fill="white"
    />
  </svg>
);
